export type Seat = {
    id: number
    price: number
    seatLabel: string    // Веранда Ряд 1 Стол 2          Стол 5        Ряд 2 Стол 5
    seatDesc: string
    segmentId: number
    segmentName: string
    //rowNumber: number
    //seatNumber: number
}

export type EntryTicket = {
    id: number // для api нужен
    segmentId: number
    segmentName: string
    price: number
    countAvailable: number
}

export type FREventResult = {
    data: EventData
    timestamp: number
}

export type EventData = {
    id: string
    sbpAvailable?: boolean
    payAvailable?: boolean
    reserveAvailable?: boolean
    svgMapName: string
    name: string
    date: string
    ageLimit: string
    legalInfo: string
    venueName: string
    venueAddress: string
    conditionsUrl: string
    supportTel: string
    supportEmail: string
    // Билет,Билеты,Билетов
    ticketNameOne: string
    ticketNameMany: string
    ticketNameOf: string
    seats?: { [key: string]: Seat }
    entryTickets?: EntryTicket[],
    userData?: {
        booking: boolean
        sales: boolean
        admin: boolean
    }
}

export type CreateOrderData = {
    eventId: string
    name: string
    email: string
    // формат с 7 без +
    tel: string
    comment?: string
    seats: number[]
    entryTickets: {
        segmentId: number
        price: number
    }[]
    // Итоговая сумма для сверки, вдруг переоценка произошла
    sum: number
}

export type PayOrderResult = {
    orderNumber: string
    orderId: string
    payUrl: string
}

export type ReserveOrderResult = {
    orderId: string
}

export type Events = {
    [id: string]: {
        id: number
        name: string
        date: string
        place: string
    }
}


export type OrderData = {
    id: string
    user: string
    clientName: string
    clientTel: string
    clientEmail: string
    date: string
    active: boolean
    count: number
    sum: number
    comment: string
    seats: string
}

export type OrdersData = {
    [id: string]: OrderData
}

export const enum PaymentSystem {
    CARD = "bankcard",
    SBP = "sbp",
    SBERPAY = "sberpay",
    TPAY = "tpay",
    YOOMONEY = "yoomoney",
}
